'use strict';

(function () {
    doljCTAVidScroll();
    hanteraBlankare();

    let map;

    if (document.getElementById('map')) {
        kartor.initieraKarta(initMap);
    }

    function doljCTAVidScroll() {
        const cta = document.getElementById('cta');
        const sticky = document.querySelector('.cta-sticky');

        if (cta) {
            const ctaObserver = new IntersectionObserver((entries, observer) => {
                for (let entry of entries) {
                    if (entry.isIntersecting) {
                        sticky.classList.add('d-none');
                        break;
                    } else if (entry.boundingClientRect.top > 0) {
                        sticky.classList.remove('d-none');
                    }
                }
            });
            ctaObserver.observe(cta);
        }
    }


    function hanteraBlankare() {
        const link = document.querySelector('.blankare-ledig-lokal');
        if (link && link.hash !== '') {
            link.addEventListener('click', function (e) {
                const hash = this.hash;
                const element = document.getElementById(hash.slice(1));
                if (element) {
                    event.preventDefault();
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            });
        }
    }

    function initMap() {

        const karta = document.getElementById('map');
        let projektlista = document.querySelectorAll('.card-projekt');

        let centreraLatitud = projektlista[0].dataset.latitud;
        let centreraLongitud = projektlista[0].dataset.longitud;

        for (let i = 0; i < projektlista.length; i++) {
            if (projektlista[i].dataset.arPrimar === 'True') {
                centreraLatitud = projektlista[i].dataset.latitud;
                centreraLongitud = projektlista[i].dataset.longitud;
            }
        }

        map = kartor.skapaKarta(karta, centreraLatitud, centreraLongitud);

        for (let i = 0; i < projektlista.length; i++) {
            markeraPlats(
                projektlista[i].dataset.latitud,
                projektlista[i].dataset.longitud,
                projektlista[i].dataset.arPrimar === 'True' ? kartor.ikonProjektPrimar : kartor.ikonProjektSekundar,
                projektlista[i]
            );
        }
        
        function markeraPlats(latitud, longitud, ikon, htmlPopup) {

            if (latitud !== '' && longitud !== '') {
                let marker = kartor.marker(latitud, longitud, map, ikon);

                kartor.hanteraPopup(map, marker, htmlPopup);
            }
        }
    }
})();
